export default {
  user: ''
}